import React, {Fragment, useRef, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import Button from "../../UI/Button";
import Input from "../../UI/Input";
import Styles from "../../UI/Inpnut.module.css"
import {ReactTabulator} from "react-tabulator";
import _axios from "../../../httpService";
import {toast} from "react-toastify";
import axios, {request} from "axios";
import Loader from "../../Loader";
import ConditionInDataChart from "./ConditionInDataChart";
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import NewTabulator from "../../NewTabulator/NewTabulator";
import {deleteRowHandler} from "../../SellFactor/SellFactorFunctions";
import tableCalc from "../../../utils/tableCalc";
import utilsFunction from "../../../utils/utilsFunction";
import {makeFullDataFromBackendData, removeRowFromConditionTable} from "./NewDataChartFunctions";

const NewDataChart = (props) => {
  const prefixUrl = localStorage.getItem("apiUrl") + "/userDashboardData/"

  const [hasConditionState, setHasConditionState] = useState(false)
  const [conditionDataFromBackEnd, setConditionDataFromBackEnd] = useState({})
  const [tableData, setTableData] = useState({
    id: "", title: "-", entity: "nullSelect", options: {
      indicator: [], fetch: [],
    },
  });
  const tableColumnsForCondition = [{
    title: "حذف",
    headerSort: false,
    formatter: "buttonCross",
    style: {width: 320, textAlign: 'center'},
    headerHozAlign: "center",

    cellClick: function (e, cell) {
      console.log("حذف حذف حذف");
      const id = cell.getData().uniqId;
      const newTable = removeRowFromConditionTable(conditionTableData, "uniqId", id)
      setConditionTableData(newTable)
    }

  }, {
    title: "ولیو فیلد", field: "field", visible: false,
  }, {
    title: "فیلد انتخابی", field: "textField", visible: true,
  }, {
    title: "operator", field: "operator", visible: false,
  }, {
    title: "عملگر", field: "textOperator", visible: true,
  }, {
    title: "مقدار", field: "value", visible: true,
  }, {
    title: "textValue", field: "textValue", visible: false,
  }, {
    title: "andOr", field: "andOr", visible: false,
  }, {
    title: "شرط", field: "textAndOr", visible: true,
  },

  ];
  const [conditionTableData, setConditionTableData] = useState([])

  const location = useLocation();
  const navigateTo = useNavigate();
  const [object, setObject] = useState({id: "", mode: undefined, type: undefined}); // Table or Chart

  const [chartData, setChartData] = useState({
    id: "", title: "", entity: "nullSelect", x: [], y: "nullSelect", arg: "nullSelect", chartType: "nullSelect",
  }); // Table or Chart
  const [tabulatorDataState, setTabulatorDataState] = useState([]); // Table or Chart
  const [entitiesBackList, setEntitiesBackList] = useState([{key: "", value: ""}]); // set From Backend
  const [indexFieldsBackList, setIndexFieldsBackList] = useState({fetch: [], indicator: []}); //

  const [isLoading, setIsLoading] = useState(true);

  const setEntityState = (isShowComponent) => {
    _axios.get(prefixUrl + "?request=entities").then((response) => {
      setEntitiesBackList(response.data)
      isShowComponent && setIsLoading(false)
    })
  }
  useEffect(() => {
    if (location.state) {

      let {id, mode, type, title} = location.state;
      if (id === undefined) id = ""
      setObject({id, mode, type, title})
      if (mode === "edit") {


        setEntityState(false);

        //باید در خواست بزنم بک بگم آقا اطلاعات رو برای ادیت بفرست
        // بعدش استیت بزارم پر بشه
        // get EntitiesList

        if (type === "table") {
          if (id !== "" || id !== undefined) {


            _axios.get(prefixUrl + "?request=tableConfig&id=" + id).then((response) => {

              setTableData(response.data);
              debugger
              setTabulatorDataState(response.data.options.fetch.data);
              setIndexFieldsBackList(ps => {
                let temp = {...ps}
                temp.indicator = response.data.options.indicator
                return temp;
              });
               //onChangeEntitiesHandler(response.data.entity, true)
debugger
              // setTableData(response.data.options.fetch)
              setConditionDataFromBackEnd(response.data.entityConditionFields)

              if (response.data.options.conditions.data.length > 0) {
                // اینجا باید یونیک آدی ست کنم
                // نام های رو به جای خودش بزارم به جای استرینگ ها معادل بزارم
                const fullTableData = makeFullDataFromBackendData(response.data.options.conditions.data ,response.data.entityConditionFields)

                // setConditionTableData(response.data.options.conditions.data)
                setConditionTableData(fullTableData)
                setHasConditionState(true)
              } else {
                setHasConditionState(false)

              }


              setIsLoading(false)
            })
          }
        } else {
          // درسته دارم توی ادد میگیرم اما اینجا استثنا باید بگیرم و بک فقط  ولیو میده
          _axios.get(prefixUrl + "?request=entities").then((entitiesResponse) => {
            // دریافت موجودیت فعلی
            _axios.get(prefixUrl + "?request=chartConfig&id=" + id).then((chartConfigResponse) => {
              _axios.get(prefixUrl + "?request=entityFields&entity=" + chartConfigResponse.data.entity).then(r => {

                debugger
                // show list of Entities in a select Box
                setEntitiesBackList(entitiesResponse.data)
                setChartData(chartConfigResponse.data);


                if (chartConfigResponse.data.conditions.data.length > 0) {
                  // اینجا باید یونیک آدی ست کنم
                  // نام های رو به جای خودش بزارم به جای استرینگ ها معادل بزارم
                  setConditionTableData(chartConfigResponse.data.conditions.data)
                  setHasConditionState(true)
                  setConditionDataFromBackEnd(r.data.entityConditionFields)

                  const fullTableData = makeFullDataFromBackendData(chartConfigResponse.data.conditions.data ,chartConfigResponse.data.entityConditionFields)
debugger
                  // setConditionTableData(response.data.options.conditions.data)
                  setConditionTableData(fullTableData)
                  setHasConditionState(true)


                } else {
                  setHasConditionState(false)

                }


                setIsLoading(false);
                // this condition added Later So i decided to add an other state
                // set Entity List


                /*
                 اگه توی دیتایی که واسه چارت لیست میفرسته  و من دارم با
                                setIndexFieldsBackList
                                .نشون میدم.
                                اگه توی چارت لیست آرایه ی ایکس پر بود پس باید من یه چکد اضافه کنم.
                                */
                const temp = {...r.data}
                debugger
                temp.entitiyFields.indicator.map(item => {

                  if (chartConfigResponse.data.x.includes(item.value)) {
                    item.checked = true;
                  }
                })

                debugger
                setIndexFieldsBackList(temp.entitiyFields)

              })


            })
          })


        }

      } else if (mode === "add") {
        // هیچی معمولی حالت افزودن رو نشون میده  ینی استیت ها خالیه
        debugger
        setEntityState(true);
      }

    } else {
      // مقادیر ورودی به صفحه صحیح نیست.
    }
  }, [])
  const cancelProcess = (event) => {
    event.preventDefault();
    // navigateTo(-1)
    // وقتی توی این کامپوننت برگشت میزنه از اینجا برمیگرده توی صفحه قبلی ولی موردی که هست جداول رو باز میکنه.
    // من با پاس دادن مقدار استیت از اینجا میخوام بگم اونجا کدوم تب رو نشون بده
    // این کار رو در دکمه ی کنسل در  صفحه ی جدول هم باید انجام بدم
// آها راستی صفحه ی جدول و چارت یکی هستند بهتره تایپ که توی آبجکت هست رو بدم
    navigateTo("/defineDashboardSettings", {state: {from: object.type}})

  };
  const submitChart = () => {

    if (chartData.title.trim() === "") {
      toast.error("لطفا یک عنوان وارد کنید.");
      return;
    }
    if (chartData.entity === "nullSelect") {
      toast.error("لطفا یک موجودیت انتخاب کنید.");
      return;
    }
    if (chartData.x.length === 0) {
      toast.error("لطفا محور X را انتخاب کنید.");
      return;
    }
    if (chartData.y === "nullSelect") {
      toast.error("لطفا محور Y را انتخاب کنید.");
      return;
    }
    if (chartData.arg === "nullSelect") {
      toast.error("لطفا نوع واکشی را انتخاب کنید.");
      return;
    }
    if (chartData.chartType === "nullSelect") {
      toast.error("لطفا نوع نمودار را انتخاب کنید.");
      return;
    }

    const sendData = {
      request: "setChartConfig", detail: chartData
    }
    if (hasConditionState) {
      if (conditionTableData.length === 0) {
        toast('لطفا یک شرط وارد کنید')
        return;
      }


      // چسباندن اطلاعات شرط به درخواست
      sendData.detail.conditions = conditionTableData
    }

    const sendRequest = _axios.post(prefixUrl, sendData).then(r => {
      if (r.data.status) {
        toast.success(r.data.message);
        // navigateTo(-1)
        navigateTo("/defineDashboardSettings", {state: {from: object.type}})
      } else {
        toast.error(r.data.message);
      }
    });


  };
  const submitTable = (event) => {
    event.preventDefault();
    if (tableData.title === "") {
      toast.error("لطفا یک عنوان وارد کنید.");
      return;
    }

    let indicators = [];
    // ok dear i wanna take the values of CheckBoxes
    let elements = checkBoxRef.current.getElementsByTagName("input");
    // import Data to indicators
    for (let element of elements) {
      if (element.checked) {
        indicators.push(element.value);
      }
    }
    // ورودی ها رو پر کرده یا نه؟
    if (indicators.length < 1) {
      toast.error("فیلد های شاخص خالی هستند!");
      return;
    }
    // tabulator data to fetch Array
    let tabulatorData = tableRefKPI.current.table.getData();
    if (tabulatorData.length < 1) {
      toast.error("فیلد های واکشی را پر کنید!");
      return;
    }

    const sendData = {
      request: "setTableConfig", detail: {
        id: object.id, entity: tableData.entity, title: tableData.title, options: {
          indicator: indicators, fetch: tabulatorData,
        },
      }
    }

    if (hasConditionState) {
      if (conditionTableData.length === 0) {
        toast('لطفا یک شرط وارد کنید')
        return;
      }

      // چسباندن اطلاعات شرط به درخواست
      sendData.detail.options.conditions = conditionTableData


    }
    const sendRequest = _axios.post(prefixUrl, sendData).then(r => {
      if (r.data.status) {
        toast.success(r.data.message);
        // navigateTo(-1)
        //برو برگرد به صفحه قبلی یادت باشه باید بخش جدول رو باز کنی
        navigateTo("/defineDashboardSettings", {state: {from: object.type}})
      } else {
        toast.error(r.data.message);
      }
    });
  };


  const tableColumns = [{
    title: "نام فیلد", field: "nameField",
  }, {
    title: "ارسالی به بک", field: "enName", visible: false,
  }, {
    title: "نوع واکشی", field: "typeOfSelect",
  }, {
    title: "نوع واکشی ارسالی به بک", field: "arg", visible: false,
  }, {
    title: "حذف",
    formatter: "buttonCross",
    width: 100,
    headerSort: false,
    resizable: false,
    hozAlign: "center",
    cellClick: function (e, cell) {
      cell.getRow().delete();
    }
  }

  ];
  const checkBoxRef = useRef();
  const refNumber1 = useRef();
  const refNumber2 = useRef();
  const tableRefKPI = useRef();
  const [selectedRow, setSelectedRow] = useState();

  const [myTabulator, setMyTabulator] = useState({
    column: [], data: [],
  });

  const addRowPlease = () => {
    if (refNumber1.current.value === "nullSelect") {
      toast.error("لطفا یک گزینه را در بخش فیلد انتخاب کنید");
      return;
    }
    if (refNumber2.current.value === "nullSelect") {
      toast.error("لطفا یک گزینه را در بخش نوع واکشی انتخاب کنید");
      return;
    }

    let tempDataTabulator = [];

    let tableDataPlease = tableRefKPI.current.table.getData();

    let objectToAdd = {
      nameField: refNumber1.current.options[refNumber1.current.selectedIndex].text,
      enName: refNumber1.current.value,
      typeOfSelect: refNumber2.current.options[refNumber2.current.selectedIndex].text,
      arg: refNumber2.current.value,
    };

    if (tableDataPlease.length > 0) {
      tableDataPlease.map((v) => {
        // اگه تکراری بود میشه لطفا اجازه ندی به جدول اضافه بشه؟
        if (JSON.stringify(v) === JSON.stringify(objectToAdd)) {
          toast.error("این مورد قبلا به جدول اضافه شده است.");
          return;
        }
        tempDataTabulator.push({
          nameField: v.nameField, enName: v.enName, typeOfSelect: v.typeOfSelect, arg: v.arg,
        });
      });
      tempDataTabulator.push(objectToAdd);
    } else {
      tempDataTabulator.push(objectToAdd);
    }
    setTabulatorDataState(tempDataTabulator);
  };

  const onChangeEntitiesHandler = (event, hasValue = false) => {

    // اگه مقدار دوم نداده بود ینی ایونت رو بررسی کن
    // اگه مقدار دوم داده درست داده بود ینی خود ولیو رو داره پاس میده
    let value = "";
    if (!hasValue) {
      value = event.target.value;
    } else {
      value = event; // actually we have value it is not an event
    }

    _axios.get(prefixUrl + "?request=entityFields&entity=" + value).then(r => {
      setIndexFieldsBackList(r.data.entitiyFields)
      // new State For conditional Data
      setConditionDataFromBackEnd(r.data.entityConditionFields)
      setConditionTableData([])

      if (object.type === "table") {
        setTabulatorDataState([])
        setTableData(ps => {
          const temp = {...ps}
          temp.entity = value;
          return temp
        })
      } else {
        setChartData(ps => {
          const temp = {...ps}
          temp.entity = value;
          temp.x = [];
          temp.y = "nullSelect";
          return temp
        })
      }
    })
  }

  const ReactTabulatorRef = useRef();

  const addToTableHandler = (row) => {

    const newRow = utilsFunction.addUniqId(row)
    setConditionTableData([...conditionTableData, {...newRow}])
  }

  return (<div className={"p-4 "}
               style={{"width": "100%", "height": "88vh", "overflow": "scroll"}}
  >
    {isLoading === false ? <div style={{
      width: '650px', margin: '0 auto',

    }}>
      <h6 className={"my-3"}>
        {/*  اینجا میخوام یه چیزی بنویسم.
             مثلا نعریف جدول جدید
            ویرایش جدول فلان
             ویرایش نمودار فلان
         */}

        {/*id , mode , type*/}
        {object.mode === "edit" ? " ویرایش " : " تعریف "}
        {object.type === "table" ? " جدول " : " نمودار "}
        «{object.title === undefined ? " جدید " : " " + object.title}»
      </h6>
      {object.type === "table" ? <>
        <div>
          <div className={"inputLabel"}>
            <label htmlFor={"tableTitle"}>عنوان جدول</label>
            <Input
              id={"tableTitle"}
              type={"text"}
              value={tableData.title}
              onChange={(event) => {
                setTableData(ps => {
                  const temp = {...tableData}
                  temp.title = event.target.value;
                  return temp
                })
              }}
            />
          </div>

          <div className={"inputLabel"}>
            <label htmlFor={"entitySelect"}>نام موجودیت</label>
            <select

              defaultValue={tableData.entity}
              value={tableData.entity}
              onChange={onChangeEntitiesHandler}
              className={`${Styles.default_input_style}`}
              id={"entitySelect"}
            >
              <option value={"nullSelect"} disabled={true} hidden={true}>انتخاب کنید</option>
              {entitiesBackList.map((ob, index) => <option value={ob.entity} key={index}>{ob.title}</option>)}
            </select>
          </div>
          <div className={"inputLabel"}>
            <label>فیلد(های) شاخص</label>
            <div
              ref={checkBoxRef}
              style={{display: 'flex', justifyContent: 'space-between', flexWrap: "wrap"}}
              className={"px-1"}
            >
              {indexFieldsBackList.indicator.map((v, index) => <div key={"" + index} style={{
                width: '50%', whiteSpace: 'nowrap', display: 'flex',
              }}
                                                                    className={"rounded py-2 px-2"}>
                <input
                  value={v.value}
                  id={"" + index}
                  type="checkbox"
                  defaultChecked={v.checked !== undefined ? v.checked : false}
                />
                <label htmlFor={"" + index}>{v.label}</label>
              </div>)}

            </div>
          </div>
          <div className={"inputLabel"}>
            <label htmlFor={"vakeshiField"}>فیلد(های) واکشی</label>
            <select
              ref={refNumber1}
              className={Styles.default_input_style}
              id={"entitySelect"}
              defaultValue={"nullSelect"}>
              <option value={"nullSelect"} disabled={true} hidden={true}>انتخاب کنید</option>
              {indexFieldsBackList.fetch.map((ob, index) => <option value={ob.value}
                                                                    key={index}>
                {ob.label}
              </option>)}
            </select>
          </div>
          <div className={"inputLabel"}>
            <label htmlFor={"vakeshiType"}>نوع واکشی</label>
            <select
              ref={refNumber2}
              className={Styles.default_input_style}
              id={"vakeshiType"}
              defaultValue={"nullSelect"}>

              <option value={"nullSelect"} hidden={true} disabled={true}>انتخاب کنید</option>
              <option value={"MIN"}>کمترین</option>
              <option value={"MAX"}>بیشترین</option>
              <option value={"AVG"}>میانگین</option>
              <option value={"SUM"}>جمع</option>
              <option value={"COUNT"}>تعداد</option>
            </select>
          </div>
          <div className={"inputLabel"}>
            <span onClick={addRowPlease} className={"btn btn-primary"} style={{width: 90}}> افزودن </span>
          </div>
          <div className={"inputLabel"}>
            <ReactTabulator
              className={"myTable1"}
              ref={tableRefKPI}
              columns={tableColumns}
              data={tabulatorDataState}
            />
          </div>


          {/**/}
          {/* سلکت آپشن دو ستونه */}

          {/*<div*/}
          {/*  style={{*/}
          {/*    display: "flex",*/}
          {/*    justifyContent: "space-between",*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <div className={"inputLabel my-0"} style={{*/}
          {/*    width: '49%',*/}
          {/*  }}>*/}
          {/*    <label>ستون اول</label>*/}
          {/*    <select className={Styles.default_input_style}>*/}
          {/*      <option>1</option>*/}
          {/*      <option>1</option>*/}
          {/*      <option>1</option>*/}
          {/*    </select>*/}
          {/*  </div>*/}
          {/*  <div className={"inputLabel my-0"}*/}
          {/*       style={{*/}
          {/*         width: '49%',*/}
          {/*       }}*/}
          {/*  >*/}
          {/*    <label>ستون اول</label>*/}
          {/*    <select className={Styles.default_input_style} style={{*/}
          {/*      // width: '45%',*/}
          {/*    }}>*/}
          {/*      <option>1</option>*/}
          {/*      <option>1</option>*/}
          {/*      <option>1</option>*/}
          {/*    </select>*/}
          {/*  </div>*/}
          {/*</div>*/}
          {Object.keys(conditionDataFromBackEnd).length > 0 && <>
            <ConditionInDataChart
              conditionDataFromBackEnd={conditionDataFromBackEnd}

              setHasConditionState={(booleanValue) => {
                debugger
                setHasConditionState(booleanValue)
              }}
              hasConditionState={hasConditionState}

              AddToTableHandler={row => addToTableHandler(row)}

              tableColumnsForCondition={tableColumnsForCondition}
              conditionTableData={conditionTableData}

            />

          </>}
          <div className={"text-center mt-5"}>
            <Button onClick={submitTable}>ثبت </Button>
            <Button onClick={cancelProcess}>انصراف </Button>
          </div>
        </div>
      </> : <>
        <div>
          <div className={"inputLabel"}>
            <label htmlFor={"chartTitle"}>عنوان نمودار </label>
            <Input
              id={"chartTitle"}
              type={"text"}
              value={chartData.title}
              onChange={(event) => {
                setChartData(ps => {
                  const temp = {...chartData}
                  temp.title = event.target.value;
                  return temp
                })
              }}
            />
          </div>
          <div className={"inputLabel"}>
            <label htmlFor={"entitySelectChart"}>نام موجودیت</label>
            <select

              defaultValue={chartData.entity}
              value={chartData.entity}
              onChange={onChangeEntitiesHandler}
              className={`${Styles.default_input_style}`}
              id={"entitySelectChart"}
            >

              <option value={"nullSelect"} disabled={true} hidden={true}>انتخاب کنید</option>
              {entitiesBackList.map((ob, index) => <option value={ob.entity} key={index}>{ob.title}</option>)}
            </select>
          </div>
          <div className={"inputLabel"}>

            <label htmlFor={"XSelectChart"}>فیلد(های) شاخص (ستون X )</label>

            <div
              style={{display: 'flex', justifyContent: 'space-between', flexWrap: "wrap"}}
              className={"px-1"}
            >
              {indexFieldsBackList.indicator.map((v, index) => <div
                key={"" + index}
                style={{
                  width: '50%', whiteSpace: 'nowrap', display: 'flex',
                }}
                className={"rounded py-2 px-2"}
              >
                <input
                  value={v.value}
                  id={"" + index}
                  type="checkbox"
                  defaultChecked={v.checked !== undefined ? v.checked : false}
                  onChange={event => {
                    const value = event.target.value;
                    setChartData(ps => {
                      const temp = {...chartData}

                      if (event.target.checked) {
                        temp.x.push(value)
                      } else {
                        let index = temp.x.indexOf(value);
                        if (index > -1) {
                          temp.x.splice(index, 1);
                        }
                      }
                      return temp
                    })
                  }}
                />
                <label htmlFor={"" + index}>{v.label}</label>
              </div>)}

            </div>


          </div>
          <div className={"inputLabel"}>
            <label htmlFor={"YChartSelect"}>فیلد(های) واکشی ستون Y</label>
            <select

              onChange={(event) => setChartData(ps => {
                let temp = {...chartData};
                temp.y = event.target.value
                return temp
              })}
              className={Styles.default_input_style}
              id={"YChartSelect"}
              // defaultValue={chartData.y}
              value={chartData.y}
            >
              <option value={"nullSelect"} disabled={true} hidden={true}>انتخاب کنید</option>
              {indexFieldsBackList.fetch.map((ob, index) => <option value={ob.value}
                                                                    key={index}>
                {ob.label}
              </option>)}
            </select>
          </div>
          <div className={"inputLabel"}>
            <label htmlFor={"vakeshiChartType"}>نوع واکشی</label>
            <select
              className={Styles.default_input_style}
              id={"vakeshiChartType"}
              defaultValue={chartData.arg}
              value={chartData.arg}
              onChange={(event) => setChartData(ps => {
                let temp = {...chartData};
                temp.arg = event.target.value
                return temp
              })}
            >

              <option value={"nullSelect"} hidden={true} disabled={true}>انتخاب کنید</option>
              <option value={"MIN"}>کمترین</option>
              <option value={"MAX"}>بیشترین</option>
              <option value={"AVG"}>میانگین</option>
              <option value={"SUM"}>جمع</option>
              <option value={"COUNT"}>تعداد</option>
            </select>
          </div>
          <div className={"inputLabel"}>
            <label htmlFor={"vakeshiChartType"}>نوع نمودار</label>
            <select
              className={Styles.default_input_style}
              id={"ChartType"}
              value={chartData.chartType}
              onChange={(event) => setChartData(ps => {
                let temp = {...chartData};
                temp.chartType = event.target.value
                return temp
              })}
            >

              <option value={"nullSelect"} hidden={true} disabled={true}>انتخاب کنید</option>
              <option value={"bar"}>میله ای</option>
              <option value={"doughnut"}>دایره ای</option>
              <option value={"line"}>خطی</option>
            </select>
          </div>
          {/**/}
          {/* سلکت آپشن دو ستونه */}
          {/*<div*/}
          {/*  style={{*/}
          {/*    display: "flex",*/}
          {/*    justifyContent: "space-between",*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <div className={"inputLabel my-0"} style={{*/}
          {/*    width: '49%',*/}
          {/*  }}>*/}
          {/*    <label>ستون اول</label>*/}
          {/*    <select className={Styles.default_input_style}>*/}
          {/*      <option>1</option>*/}
          {/*      <option>1</option>*/}
          {/*      <option>1</option>*/}
          {/*    </select>*/}
          {/*  </div>*/}
          {/*  <div className={"inputLabel my-0"}*/}
          {/*       style={{*/}
          {/*         width: '49%',*/}
          {/*       }}*/}
          {/*  >*/}
          {/*    <label>ستون دوم</label>*/}
          {/*    <select className={Styles.default_input_style} style={{*/}
          {/*      // width: '45%',*/}
          {/*    }}>*/}
          {/*      <option>1</option>*/}
          {/*      <option>1</option>*/}
          {/*      <option>1</option>*/}
          {/*    </select>*/}
          {/*  </div>*/}
          {/*</div>*/}
          {Object.keys(conditionDataFromBackEnd).length > 0 && <>
            <ConditionInDataChart
              conditionDataFromBackEnd={conditionDataFromBackEnd}

              setHasConditionState={(booleanValue) => {
                debugger
                setHasConditionState(booleanValue)
              }}
              hasConditionState={hasConditionState}

              AddToTableHandler={row => addToTableHandler(row)}

              tableColumnsForCondition={tableColumnsForCondition}
              conditionTableData={conditionTableData}

            />

          </>}

          <div className={"text-center mt-5"}>
            <Button onClick={submitChart}>ثبت </Button>
            <Button onClick={cancelProcess}>انصراف </Button>
          </div>
        </div>
      </>}
    </div> : <Loader/>}
  </div>);
};

export default NewDataChart;
